import { useState, useEffect } from "react";
import AppClass from "../../../../AppClass";
import { Card } from "../../../Card";
import toastMessage from "../../../toastMessage";

export default function GeneralSettings({ token, apps, user_id, role }) {
  const [appid, setAppid] = useState(null);
  const [settings, setSettings] = useState(null);
  const [fees, setFees] = useState({});
  const [fee, setFee] = useState('');
  const [errors, setErrors] = useState({});
  const [other, setOther] = useState({});
  const [notifications, setNotifications] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apps.length > 0) {
      setAppid(apps[0]);
      getSettings(apps[0].value);
    }
  }, [apps]);

  const getSettings = (app_id) => {
    setIsLoading(true);

    const body = {
      app_ids: [app_id],
      model: "setting",
      tag: "by_appid",
    };

    AppClass.get_setting_data(body)
      .then((data) => {
        if (data?.data?.length > 0) {
          setSettings(data?.data[0]);
          setFees(data?.data[0]?.fees);
          setOther(data?.data[0]?.other);
          setNotifications(data?.data[0]?.notifications);
        } else {
          setSettings(null);
        }
      })
      .catch((err) => {
        toastMessage("error",
          err?.response?.data?.error ||
          err?.message ||
          "Error fetching settings"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handleRemoveFee = (fee) => {
    setFees((prev) => {
      const newFees = { ...prev };
      delete newFees[fee];
      return newFees;
    });
  };

  const handleAddFee = () => {
    if (!fee) {
      setErrors({ fees: "Fee name is required" });
      return;
    }

    setFees((prev) => ({ ...prev, [fee]: true }));
    setFee('');
    setErrors((prev) => ({ ...prev, fees: null }));
  };

  const handleSave = () => {
    setIsSubmitting(true);

    const body = {
      id: settings._id,
      fees: fees,
      other: other,
      notifications: notifications,
    };

    AppClass.update_setting_data(body)
      .then(() => {
        getSettings(appid?.value);
        toastMessage("success", "Settings saved successfully");
      })
      .catch((err) => {
        toastMessage("error",
          err?.response?.data?.error ||
          err?.message ||
          "Error saving settings"
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Card className="col-md-8 col-md-offset-2">
      {isLoading ? (
        <div className="text-center">
          <span>Loading...</span>
        </div>
      ) : (
        <>
          <div style={{ padding: "2rem 2rem" }}>
              <div className="panel">
              <div className="panel-heading card-title">
                <span>Loan Fees</span>
              </div>
              <div className="panel-body">
                {Object.keys(fees || {}).length > 0 ?
                  (Object.keys(fees).map((el, i) => {
                    return (
                      <div
                        className="form-group"
                        key={i}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <div style={{ marginRight: "1rem" }}>
                          <span>{i + 1}. {el}</span>
                        </div>
                        <div
                          onClick={() => handleRemoveFee(el)}
                          style={{ cursor: "pointer", color: "red" }}
                        >
                          <i className="fa fa-times"></i>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center">
                    <span>No fees created yet</span>
                  </div>
                )}
                <hr />
                <div>
                  <span>Create Custom Loan Fees</span>
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Fee Name</label>
                        <input
                          className="form-control"
                          onChange={(e) => setFee(e.target.value)}
                          value={fee}
                          placeholder="Enter Fee Name e.g. Processing Fee"
                        />
                        {errors.fees && (
                          <span className="text-danger">{errors.fees}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: "2.8rem" }}>
                      <button
                        className="btn btn-primary"
                        onClick={handleAddFee}
                      >
                        Add Fee
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "0 2rem" }}>
            <div className="panel">
              <div className="panel-heading card-title">
                <span>Payment Sources</span>
              </div>
              <div className="panel-body">
                <div>
                  <span>Select Allowed Payment Sources</span>
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            onChange={(e) => setOther({ ...other, pos: e.target.checked })}
                            checked={other["pos"]}
                            type="checkbox"
                          />
                          <span style={{ marginLeft: "1rem" }}>POS Device</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            onChange={(e) => setOther({ ...other, dashboardPaymentsEnabled: e.target.checked })}
                            checked={other["dashboardPaymentsEnabled"]}
                            type="checkbox"
                          />
                          <span style={{ marginLeft: "1rem" }}>
                            Loans & Saving Dashboard
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "0 2rem" }}>
            <div className="panel">
              <div className="panel-heading card-title">
                <span>Notifications</span>
              </div>
              <div className="panel-body">
                <div>
                  <span>Enable notifications</span>
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            onChange={(e) => setNotifications({ ...notifications, transactions: e.target.checked })}
                            checked={notifications["transactions"]}
                            type="checkbox"
                          />
                          <span style={{ marginLeft: "1rem" }}>
                            Send SMS on each transaction (NOTE: A fee of KES 2.00 will be charged for each SMS)
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "2rem 2rem", display: "flex", justifyContent: "center" }}> 
            <button
              className="btn btn-primary"
              disabled={isSubmitting}
              onClick={handleSave}
            >
              <i className="fa fa-save"></i>
              {isSubmitting ? "  Saving..." : "  Save"}
            </button>
          </div>
        </>
      )}
    </Card>
  );
}

